/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"], t = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], n = "Jahre", a = "Jahr", o = "Monat", s = "Woche", c = "Tage", r = "Tag", d = "Heute", g = "Keine Events", i = "Ganztägig", M = "Löschen", l = "Event erstellen", u = "dddd D MMMM YYYY", h = {
  weekDays: e,
  months: t,
  years: n,
  year: a,
  month: o,
  week: s,
  days: c,
  day: r,
  today: d,
  noEvent: g,
  allDay: i,
  deleteEvent: M,
  createEvent: l,
  dateFormat: u
};
export {
  i as allDay,
  l as createEvent,
  u as dateFormat,
  r as day,
  c as days,
  h as default,
  M as deleteEvent,
  o as month,
  t as months,
  g as noEvent,
  d as today,
  s as week,
  e as weekDays,
  a as year,
  n as years
};
